import { Section } from '@tracsis/library/src';
import cx from 'classnames';
import React from 'react';

const EmptyList = ({
	children,
	className = '',
	background = 'grey',
}: {
	children: React.ReactNode;
	className?: string;
	background?: 'grey' | 'white';
}) => {
	return (
		<Section background={background} className={cx(className)}>
			{children}
		</Section>
	);
};

export default EmptyList;
